import Layout from "./components/Layout/Layout";
import "./App.css";

function App() {
  return(
  <div className="app">
    <Layout />
  </div> 
  
)}

export default App;
